import { toGlobalId } from 'graphql-relay';
import { CourseCompletionOrderEnum } from '../../../graphql/gqlTypes/transformToEnums/CourseCompletionOrderEnum';

export default function getFieldsFromOffer(
  offer,
  states,
  preRequisitesData = {},
  offerContentSetting
) {
  const children = offer.children || [];
  const totalCards = children.reduce(
    (accumulator, currentItem) => accumulator + (currentItem.children || []).length,
    0
  );
  const coursePerformance = states.find(state => state.contentId === offer._id);
  let orderOfCompletion = offer.orderOfCompletion;
  if (!orderOfCompletion) {
    orderOfCompletion = CourseCompletionOrderEnum.anyOrder;
  } else {
    orderOfCompletion = CourseCompletionOrderEnum[orderOfCompletion];
  }

  const isGradable = !!(
    offer.successStatusRollupRules && offer.successStatusRollupRules.length > 0
  );
  const fields = {
    ...offer,
    id: toGlobalId('Course', offer._id.toString()),
    pid: offer._id.toString(),
    companyId: offer.content.companyId,
    name: (offerContentSetting && offerContentSetting.name) || offer.content.name,
    description: offer.content.description,
    duration: offer.content.duration,
    image: offer.content.picture,
    contributeToSuccessStatus: offer.contributeToSuccessStatus,
    cardLockData: offer.cardLockData,
    deactivateFrom: '',
    progressWeight: offer.progressWeight,
    deleted: offer.deleted,
    isGradable,
    orderOfCompletion,
    coursePerformance: {
      totalCards,
      ...coursePerformance
    },
    badge:
      offer.badge ||
      (offer.contentSettings && offer.contentSettings.badge
        ? typeof offer.contentSettings.badge === 'object'
          ? JSON.stringify(offer.contentSettings.badge)
          : offer.contentSettings.badge
        : null),
    certificateEnabled:
      offer.certificateEnabled ||
      (offer.contentSettings ? offer.contentSettings.certificateEnabled : null),
    totalCards,
    teachers: [], // TODO
    prerequisites: [] // TODO
  };
  return fields;
}
